let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page765_game0/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page765_game0/audio/15_happy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 230,
        x: 420,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/23_daddy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 330,
        x: 695,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/16_sad.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 120,
        x: 910,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/18_angry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 150,
        x: 1360,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/25_brother.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 310,
        x: 1090,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/28_grandpa.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 340,
        x: 1560,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/20_hungry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 448,
        x: 1405,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/24_sister.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 465,
        x: 910,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/22_mummy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 545,
        x: 720,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/27_grandma.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 615,
        x: 1160,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/17_calm.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 560,
        x: 1600,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/26_baby.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 700,
        x: 1440,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/21_scared.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 680,
        x: 920,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game0/audio/19_sleepy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game0/img/audioOn.png', iconOff: 'games/page765_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 710,
        x: 450,
      },
      unit: 'px',
    },
  ],
};

export default elements;
